import React, { createContext, useCallback, useContext, useState } from "react";

interface PageSubHeaderValue {
  subtitle: React.ReactNode | null;
  actions: React.ReactNode | null;
  setPageMeta: (
    subtitle: React.ReactNode | null,
    actions?: React.ReactNode | null,
  ) => void;
}

const PageSubHeaderContext = createContext<PageSubHeaderValue>({
  subtitle: null,
  actions: null,
  setPageMeta: () => {},
});

export const PageSubHeaderProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [subtitle, setSubtitle] = useState<React.ReactNode | null>(null);
  const [actions, setActions] = useState<React.ReactNode | null>(null);

  const setPageMeta = useCallback(
    (sub: React.ReactNode | null, acts: React.ReactNode | null = null) => {
      setSubtitle(sub);
      setActions(acts);
    },
    [],
  );

  return (
    <PageSubHeaderContext.Provider value={{ subtitle, actions, setPageMeta }}>
      {children}
    </PageSubHeaderContext.Provider>
  );
};

export const usePageSubHeader = () => useContext(PageSubHeaderContext);
